import { useState } from "react";

interface MapSearchBarProps {
  onSearch: (query: string, type: string) => void;
  onClear: () => void;
}

const searchTypes = [
  { value: "cta", label: "Código CTA" },
  { value: "especie", label: "Espécie" },
  { value: "logradouro", label: "Logradouro" },
  { value: "bairro", label: "Bairro" },
  { value: "uc", label: "UC / Área verde" },
];

export default function MapSearchBar({ onSearch, onClear }: MapSearchBarProps) {
  const [query, setQuery] = useState("");
  const [searchType, setSearchType] = useState("cta");
  const [showTypeDropdown, setShowTypeDropdown] = useState(false);

  const handleSearch = () => {
    if (query.trim()) {
      onSearch(query.trim(), searchType);
    }
  };

  const handleClear = () => {
    setQuery("");
    onClear();
  };

  const selectedType = searchTypes.find((t) => t.value === searchType);

  return (
    <div className="flex items-center gap-0">
      {/* Type selector */}
      <div className="relative">
        <button
          onClick={() => setShowTypeDropdown(!showTypeDropdown)}
          className="h-10 px-3 text-xs font-medium text-foreground-700 bg-background-50 border border-background-200 rounded-l-btn hover:bg-background-100 transition-colors flex items-center gap-1.5 whitespace-nowrap"
        >
          {selectedType?.label || "Buscar"}
          <i className="ri-arrow-down-s-line text-xs text-foreground-400"></i>
        </button>

        {showTypeDropdown && (
          <>
            <div className="fixed inset-0 z-40" onClick={() => setShowTypeDropdown(false)}></div>
            <div className="absolute top-full left-0 mt-1 w-40 bg-white border border-background-200 rounded-card shadow-lg z-50 py-1">
              {searchTypes.map((type) => (
                <button
                  key={type.value}
                  onClick={() => { setSearchType(type.value); setShowTypeDropdown(false); }}
                  className={`w-full text-left px-3 py-2 text-xs transition-colors whitespace-nowrap ${
                    searchType === type.value
                      ? "bg-primary-50 text-primary-700 font-medium"
                      : "text-foreground-600 hover:bg-background-100"
                  }`}
                >
                  {type.label}
                </button>
              ))}
            </div>
          </>
        )}
      </div>

      {/* Search input */}
      <div className="relative flex-1">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") handleSearch(); }}
          placeholder={`Buscar por ${selectedType?.label.toLowerCase()}...`}
          className="w-full h-10 px-3 text-xs border border-background-200 border-l-0 bg-white text-foreground-700 focus:outline-none focus:border-accent-400 focus:ring-1 focus:ring-accent-300 transition-colors"
        />
        {query && (
          <button
            onClick={handleClear}
            className="absolute right-10 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-foreground-400 hover:text-foreground-600 transition-colors"
            title="Limpar busca"
          >
            <i className="ri-close-line text-sm"></i>
          </button>
        )}
        <button
          onClick={handleSearch}
          className="absolute right-0 top-0 h-10 w-10 flex items-center justify-center bg-accent-500 text-white rounded-r-btn hover:bg-accent-600 transition-colors"
          title="Buscar"
        >
          <i className="ri-search-line text-sm"></i>
        </button>
      </div>
    </div>
  );
}